<template>
  <div class="content-holder">
    <div class="pamm-content wow fadeIn">
      <div class="title-holder">
        <h4>{{$t("become_ib.heading")}}</h4>
        <p class="f-13" v-html="$t('become_ib.description')"></p>
      </div>
    </div>
    <div class="pamm-manager wow fadeInLeft" data-wow-delay="0.3s">
      <h3>{{$t("become_ib.sub_heading")}}</h3>
      <ul>
        <li>{{$t("become_ib.point_one")}}</li>
        <li>{{$t("become_ib.point_two")}}</li>
      </ul>
      <p>{{$t("become_ib.note_one")}}</p>
    </div>
    <!-- <div class="pamm-manager wow ib-content fadeInLeft" data-wow-delay="0.3s">
      <img src="assets/images/ib-page.png" alt="" />
    </div> -->
    <div
      class="pamm-benefits ib-content2 wow fadeInRight"
      data-wow-delay="0.3s"
    >
      <div class="benefits">
        <p>{{$t("become_ib.earn_with")}} <br />{{$t("become_ib.zero_investment_or")}} <br />{{$t("become_ib.experience")}}</p>
      </div>
      <div class="benefits">
        <p>{{$t("become_ib.weekly_ib")}} <br /> {{$t("become_ib.commissions")}} <br /> {{$t("become_ib.payouts")}}</p>
      </div>
      <div class="benefits">
        <p>{{$t("become_ib.unlimited")}} <br />{{$t("become_ib.earnings")}} <br />{{$t("become_ib.potential")}}</p>
      </div>
      <div class="benefits">
        <p>{{$t("become_ib.sub_cont_point_four")}}</p>
      </div>
      <div class="benefits">
        <p>{{$t("become_ib.ultra_fast")}} <br /> {{$t("become_ib.withdrawals_of_ib")}} <br /> {{$t("become_ib.commission")}}
        </p>
      </div>
      <div class="benefits">
        <p>{{$t("become_ib.easy_user")}} <br /> {{$t("become_ib.interface_of")}} <br />{{$t("become_ib.ib_portal")}}</p>
      </div>
      <div class="benefits">
        <p>{{$t("become_ib.dedicated")}} <br />{{$t("become_ib.account")}} <br />{{$t("become_ib.manager")}}</p>
      </div>
      <div class="benefits">
        <p>{{$t("become_ib.helpful_and")}} <br />{{$t("become_ib.free_marketing")}} <br />{{$t("become_ib.material")}}</p>
      </div>
    </div>
    <div class="btn-holder t-center">
      <a href="https://ib.aaafx.com/register" target="_blank" class="btn btn-yellow">{{$t("become_ib.become_an_ib")}}</a>
    </div>
  </div>
</template>
